function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.772 1.07a1.5 1.5 0 01.514.514l8.826 14.7a1.5 1.5 0 01-1.286 2.272H2.173a1.5 1.5 0 01-1.285-2.273l8.826-14.7a1.5 1.5 0 012.058-.513zM11 13.667c-.797 0-1.451.61-1.522 1.388l-.006.14.006.139c.067.732.65 1.316 1.383 1.382l.139.006.14-.006a1.528 1.528 0 00-.14-3.05zm1.037-8.556H9.99l-.093.006c-.24.03-.423.188-.426.38v.02l.465 6.562.013.067c.055.174.262.3.505.298h1.09l.09-.005c.231-.029.413-.176.428-.36l.464-6.562-.004-.07c-.033-.183-.235-.327-.486-.336z",
  fill: "#FCA000",
  fillRule: "evenodd"
});

var SvgWarning = function SvgWarning(props) {
  return React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19"
  }, props), _ref);
};

export default SvgWarning;